import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  reportsDataService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';

import controller from './bulk-archive-report-instance.controller';
import directive from './bulk-archive-report-instance.directive';

export default angular.module('app.components.reports.myReports.reportType.bulkArchiveReportInstance', [
    alerts,
    actionIcon,
    confirmDialog,
    loaderService,
    ssDialogService,
    reportsDataService,
  ])
  .directive('bulkArchiveReportInstance', directive)
  .controller('BulkArchiveReportInstanceController', controller)
  .name;

console.log('aapp.components.reports.myReports.reportType.bulkArchiveReportInstance created');
